module.exports = __webpack_public_path__ + "img/pantalla-8-1.0ca20071.png";